<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="h6">Modes: </span>
      <ed-dropdown :selected="selectedMode" :listItems="createModeList" :isSelected="setSelectedMode" styles="margin-bottom: 1rem;min-width: 10rem;" customClass="ed-dropdown__sm"/>
    </div>
    <p class="wikiDescription__text" v-if="selectedMode === 'Detailed'">
      <span class="h6 frequency__header"> Word Frequency </span>
      <table class="wikiDescription__frequency-box table table-stripped">
        <thead>
          <tr>
          <th>Index</th>
          <th>Word</th>
          <th>Frequency</th>
          </tr>
        </thead>
        <tbody>
          <tr class="wikiDescription__frequency" v-for="(freqs, index) in detailedFrequency" :key="index">
            <td>{{index + 1}}.</td>
            <td class="wikiDescription__frequency--head">{{ freqs.word }}</td>
            <td class="wikiDescription__frequency--tail">{{ freqs.frequency }}</td>
          </tr>
        </tbody>
      </table>
    </p>
    <p class="wikiDescription__text" v-else-if="selectedMode === 'Sentences'">
      <ul class="wikiDescription__sentences-box">
        <li
          class="wikiDescription__sentences"
          v-for="(sentence, index) in sentenceMode"
          :key="index"
          :class="{
            'wikiDescription__sentences--happy': sentence.sentiment > 0,
            'wikiDescription__sentences--sad': sentence.sentiment < 0,
            'wikiDescription__sentences--normal': sentence.sentiment === 0
          }"
          v-html="sentence.text"></li>
      </ul>
    </p>
    <p class="wikiDescription__text marked-up-container" v-else-if="selectedMode === 'Marked Up'" v-html="markedContext(markedUpMode)">
    </p>
    <p class="wikiDescription__text d-flex flex-wrap" v-else-if="selectedMode === 'Entities'">
      <span class="wikiDescription__entities" v-for="(entity, index) in entitiyMode" :key="index" :class="entityClass(entity.type)">
        <span class="wikiDescription__entities--type">{{ entity.type }}</span>
        <span class="wikiDescription__entities--entity">{{ entity.entity}}</span>
      </span>
    </p>
    <p class="wikiDescription__text" v-else v-html="markedContext(content)">
    </p>
  </div>
</template>

<script>
import marked from 'marked';
import winkNLP from 'wink-nlp';
import model from 'wink-eng-lite-web-model';
import its from 'wink-nlp/src/its';
import as from 'wink-nlp/src/as';
import convertObjToArray from '@/plugins/convertObjToArray';
import convertObjToString from '@/plugins/convertObjToString';
import edDropdown from './ed-forms/ed-dropdown.vue';

export default {
  name: 'ExploreDescription',

  props: ['content', 'Mode'],

  data() {
    return {
      description: this.content || '',
      selectedMode: this.Mode || 'Default',
      modeList: this.$store.state.explore_description_settings.modes,
    };
  },

  components: {
    edDropdown,
  },

  computed: {
    markedUpMode() {
      const nlp = winkNLP(model);
      const doc = nlp.readDoc(this.content);
      console.log(this.content);
      const obj = [];
      doc.tokens().each((e) => {
        const temp = {};
        temp.word = e.out();
        temp.type = e.out(its.pos);
        obj.push(temp);
      });
      const str = convertObjToString(obj);
      return str;
    },

    entitiyMode() {
      console.log(this.content);
      const nlp = winkNLP(model);
      const doc = nlp.readDoc(this.content);
      console.log(doc);
      const convertArrToTypeObj = (arr) => (wordType) => arr.map((e) => ({ entity: e, type: wordType }));
      const obj = [];
      const NOUNS = [];
      const PRONOUNS = [];
      doc.tokens().each((t) => {
        if (
          !t.parentEntity()
          && (t.out(its.pos) === 'NOUN' || t.out(its.pos) === 'PROPN')
        ) {
          const type = t.out(its.pos);
          const val = t.out();
          if (type === 'PROPN' && PRONOUNS.indexOf(val) === -1) {
            PRONOUNS.push(val);
          } else if (type === 'NOUN' && NOUNS.indexOf(val) === -1) {
            NOUNS.push(val);
          }
        }
      });
      doc.entities().each((e) => {
        const temp = {};
        temp.entity = e.out();
        temp.type = e.out(its.type);
        obj.push(temp);
      });
      return [
        ...convertArrToTypeObj(PRONOUNS)('PROPN'),
        ...convertArrToTypeObj(NOUNS)('NOUN'),
        ...obj];
    },

    sentenceMode() {
      const nlp = winkNLP(model);
      const doc = nlp.readDoc(this.content);
      const sentences = [];
      doc.sentences().each((s) => {
        sentences.push({ sentiment: s.out(its.sentiment), text: s.out() });
      });
      console.log('SENTENCES', sentences);
      return sentences;
    },

    detailedFrequency() {
      const nlp = winkNLP(model);
      const doc = nlp.readDoc(this.content);
      console.log('DETAILED');
      console.log(this.content);
      console.log(doc);
      // eslint-disable-next-line
      const frequency = doc.tokens().filter((t) => {
        if (!t.out(its.stopWordFlag) && t.out(its.type) === 'word') {
          return t;
        }
      }).out(its.normal, as.bow);
      const freqs = convertObjToArray(frequency);
      const sorted = freqs.sort((a, b) => b.frequency - a.frequency);
      return sorted;
    },
    createModeList() {
      const newList = [];
      this.modeList.map((mode) => newList.push(mode.mode));
      return newList;
    },
    getEmoji(count) {
      if (count > 0) {
        return 'wikiDescription__sentences--happy';
      } if (count < 0) {
        return 'wikiDescription__sentences--sad';
      }
      return 'wikiDescription__sentences--normal';
    },
  },

  methods: {
    entityClass(type) {
      if (type === 'DATE' || type === 'PROPN') {
        return 'entity--date';
      }
      if (type === 'ORDINAL') {
        return 'entity--ordinal';
      }
      if (type === 'CARDINAL') {
        return 'entity--cardinal';
      }
      if (type === 'URL' || type === 'NOUN') {
        return 'entity--url';
      }
      return 'entity--other';
    },

    selectMode(event) {
      this.selectedMode = event.target.value;
      console.log(this.selectedMode);
    },

    markedContext(content) {
      return marked(content, { sanitize: false });
    },
    setSelectedMode(tab) {
      this.selectedMode = tab;
    },
  },

};
</script>

<style lang="scss" scoped>
</style>
